//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Layout2d.js";
import "../Display/Display.DynamicSectionBuilder.js";
import "../no/SelectTaggedObjectList.js";
import "../no/ugmath.js";
import "../no/SelectObjectList.js";
let d=[[[0,"ComponentName",1,0],[0,"Method",1,0],[1,"SelectedObjects",0,"SelectTaggedObjectList",0],[0,"Settings",1,"Layout2d.CreateComponentFrom3DSettingsBuilder",0]],[[["part"],"SetSourcePart",{},1,0],[[],"GetSourcePart",{R_:{part:"Part"}},0,0],[["origin","yAxis","zAxis"],"SetProjectionPlane",{},3,0],[["origin","orientation"],"GetProjectionPlane",{},0,0]],[]];
SPLM.Layout2d.CreateComponentFrom3DBuilder = class extends SPLM.Display.DynamicSectionBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Layout2d.CreateComponentFrom3DBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Layout2d.CreateComponentFrom3DBuilder.CreateMethod = Object.freeze({
    "Section" : "Section", "Plane" : "Plane"});

export default SPLM;